import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import ThankYou from "./pages/ThankYou";
import ServicePage from "./pages/ServicePage";
import CityPage from "./pages/CityPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/bedankt" element={<ThankYou />} />
          <Route path="/inloopdouche-plaatsen" element={<ServicePage />} />
          <Route path="/badkamer-renoveren" element={<ServicePage />} />
          <Route path="/toilet-renoveren" element={<ServicePage />} />
          <Route path="/zakelijke-toiletrenovatie" element={<ServicePage />} />
          <Route path="/badkamer-renoveren/:city" element={<CityPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
